import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PageHeader } from '../../../shared/page-header/page-header';
import { AuthService } from '../../../core/auth/auth.service';
import { Client } from '../../../core/client/client.models';
import { ClientService } from '../../../core/client/client.service';
import {
  STATUS_LABELS as CLIENT_STATUS_LABELS,
  statusBadge as clientStatusBadge,
} from '../../../core/client/client.labels';
import {
  PRIORITY_LABELS,
  STATUS_LABELS as TICKET_STATUS_LABELS,
  priorityBadge,
  statusBadge as ticketStatusBadge,
} from '../../../core/ticket/ticket.labels';

@Component({
  selector: 'app-client-detail',
  imports: [RouterLink, DatePipe, PageHeader],
  templateUrl: './client-detail.html',
})
export class ClientDetail implements OnInit {
  private readonly service = inject(ClientService);
  private readonly route = inject(ActivatedRoute);
  protected readonly auth = inject(AuthService);

  protected readonly client = signal<Client | null>(null);
  protected readonly loading = signal(true);
  protected readonly error = signal<string | null>(null);

  protected readonly clientStatusLabels = CLIENT_STATUS_LABELS;
  protected readonly clientStatusBadge = clientStatusBadge;
  protected readonly ticketStatusLabels = TICKET_STATUS_LABELS;
  protected readonly priorityLabels = PRIORITY_LABELS;
  protected readonly ticketStatusBadge = ticketStatusBadge;
  protected readonly priorityBadge = priorityBadge;

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.service.get(id).subscribe({
      next: (detail) => {
        this.client.set(detail.client);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Não foi possível carregar o cliente.');
        this.loading.set(false);
      },
    });
  }
}
